import { FC } from 'react';
import { Switch } from '../../uiLibraryImports';
import styles from './smallSwitch.module.scss';

const SmallSwitch: FC<{ checked: boolean; onChange: Function; disable?: boolean }> = ({
    checked,
    onChange,
    disable
}: {
    checked: boolean;
    onChange: Function;
    disable?: boolean;
}) => {
    return (
        <div className={styles['small-switch']}>
            <Switch checked={checked} onChange={event => onChange(event.target.checked)} disabled={disable} />
        </div>
    );
};

export default SmallSwitch;
